/**
 * (c) 2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
const commonSizes = {
  px: "1px",
  0.5: "0.11rem",
  1: "0.22rem",
  1.5: "0.33rem",
  2: "0.44rem",
  2.5: "0.55rem",
  3: "0.66rem",
  3.5: "0.77rem",
  4: "0.88rem",
  5: "1.1rem",
  6: "1.32rem",
  7: "1.54rem",
  8: "1.76rem",
  9: "1.98rem",
  10: "2.2rem",
  12: "2.64rem",
  14: "3.08rem",
  16: "3.52rem",
  20: "4.4rem",
  24: "5.28rem",
  28: "6.16rem",
  32: "7.04rem",
  36: "7.92rem",
  40: "8.8rem",
  44: "9.68rem",
  48: "10.56rem",
  52: "11.44rem",
  56: "12.32rem",
  60: "13.2rem",
  64: "14.08rem",
  72: "15.84rem",
  80: "17.6rem",
  96: "21.12rem",
};

export default commonSizes;
